import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = comics
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : '';
  };

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日新鲜，精彩不断</p>
          </div>
          <Link
            to="/category/fantasy"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 最新更新`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-medium text-sm text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
                  <div className="flex flex-wrap items-center gap-1.5 mt-2">
                    {comic.genres.slice(0, 2).map((genre) => (
                      <span
                        key={genre}
                        className="px-2 py-0.5 rounded-md text-[10px] bg-secondary-100 text-secondary-700 whitespace-nowrap"
                      >
                        {getCategoryName(genre)}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(comic.views / 10000).toFixed(0)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {comic.rating}
                  </span>
                  <span className="ml-auto">
                    更新至{comic.chapters.length}话
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}